module.exports = __webpack_public_path__ + "cd455783/img/pwrd-by-sourcery-black.bba9ba41.svg";